exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".component---2XwXQ {\n  display: block;\n  margin: 2px; }\n\n.assignedClass---3B6qD {\n  padding: 2px; }\n\n.button---20aOa, .assign---2sHWI {\n  height: 25px;\n  background-color: #415667;\n  border-radius: 15px;\n  color: #fff;\n  font-family: Poppins, sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  border: 1px solid #959595;\n  margin-left: 5px;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center; }\n\n.assign---2sHWI {\n  min-width: 110px;\n  display: inline-block;\n  padding: 0 15px; }\n\n.assign---2sHWI > div {\n    height: 100%; }\n", ""]);

// exports
exports.locals = {
	"component": "component---2XwXQ",
	"assignedClass": "assignedClass---3B6qD",
	"button": "button---20aOa",
	"assign": "assign---2sHWI"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/assigned-classes-groups/index.scss
// module id = 1116
// module chunks = 3